import { useQuery } from '@tanstack/react-query';

import * as api from './whatsapp-log.api';

import type { WhatsAppLogQuery } from '@utazzo/shared';

export const useWhatsAppLogMessages = (query: WhatsAppLogQuery, enabled = true) =>
  useQuery({
    queryKey: ['whatsapp-log', 'messages', query],
    queryFn: () => api.listWhatsAppLogMessages(query),
    enabled,
    staleTime: 15_000,
  });

export const useWhatsAppLogCalls = (query: WhatsAppLogQuery, enabled = true) =>
  useQuery({
    queryKey: ['whatsapp-log', 'calls', query],
    queryFn: () => api.listWhatsAppLogCalls(query),
    enabled,
    staleTime: 15_000,
  });
